<template lang="pug">
el-table(:data="detailList" style="width: 100%;margin-bottom: 20px;")
  el-table-column(prop="factory_qc_name" label="厂商全称" width="200")
  el-table-column(prop="factory_short_name" label="厂商简称")
  el-table-column(prop="admin_name", label="姓名")
  el-table-column(prop="company", label="公司" width="200")
  el-table-column(prop="position" label="职位")
  el-table-column(prop="admin_phone" label="手机号")
  el-table-column(prop="admin_email" label="邮箱")
  el-table-column(prop="operationtime" label="报名时间" width="150") 
  el-table-column(prop="operationtime" label="支付时间" width="150") 
</template>

<script>
import axios from 'axios'
export default {
  props: ['id'],
  data () {
    return {
      detailList: null,
      newList: null
    }
  },
  methods: {
    handleClick () {
      //
    },
    // 详情
    // async getListdetail () {
    //   try {
    //     let data = {
    //       page: 1,
    //       pageSize: 10,
    //       enterprise_account_id: this.enterprise_account_id

    //     }
    //     let detaulList = await this.requests.salesListNewByAccount(data)
    //     console.log('detaulList', detaulList)
    //   } catch (err) {
    //     this.$message.error(err)
    //   }
    // },
    // 详情
    async getListdetail () {
      let url = this.$config.API.sales.listNewByAccount
      axios.get(url, {
        params: {
          // page: 1,
          // pageSize: 10,
          enterprise_account_id: this.id
        }
      }).then(res => {
        this.detailList = res.data.data.applyexplainList
        console.log('detailList', this.detailList)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 数据
    async getListNew () {
      console.log('get')
      try {
        let list = await this.requests.salesListNew()
        console.log('list', list)
        this.newList = list.data.data.applyexplainList
      } catch (err) {
        this.$message.error(err)
      }
    }
  },
  mounted () {
    this.getListdetail()
    this.getListNew()
  }
}
</script>


// WEBPACK FOOTER //
// detail.vue?7af77f08